import PropTypes from "prop-types";
import {
  FooterContainer,
  Text,
  CustomContainer,
} from "../../atoms/DependencyHelper";
import config from "../../../config/index";
import styles from "./CheckoutFooter.module.scss";

const CheckoutFooter = ({ orderSummeryVariant }) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;

  return (
    <FooterContainer
      className={`${styles["checkout-footer"]} ${
        orderSummeryVariant == "plain"
          ? styles["step-plain"]
          : styles["step-popup"]
      }`}
    >
      <CustomContainer className={styles["container"]}>
        <div className={styles["left-section"]}>
          <Text id={`checkout-footer-secure-by`}>Secured by:</Text>
          <img
            className={styles["secure-img"]}
            src={`${imagePrefix}/assets/images/symantec.png`}
            id={`checkout-footer-secure-by-symantec`}
          />
          <img
            className={styles["secure-img"]}
            src={`${imagePrefix}/assets/images/digicert.png`}
            id={`checkout-footer-secure-by-digicert`}
          />
        </div>
        <div className={styles["right-section"]}>
          <img
            className={styles["question-img"]}
            src={`${imagePrefix}/assets/images/question.svg`}
          />
          <Text
            className={styles["help-text"]}
            id={`checkout-footer-help-text`}
          >
            Need help?
            <span
              className={styles["contact-text"]}
              id={`checkout-footer-contact`}
            >
              <span
                className="d-none d-md-inline"
                id={`checkout-footer-contact-call`}
              >
                {" "}
                Call 082 135
              </span>{" "}
              <span
                className="d-md-none"
                id={`checkout-footer-contact-call-mob`}
              >
                <a href="tel:082135">Call us</a>
              </span>{" "}
              for assistance.
            </span>
          </Text>
        </div>
      </CustomContainer>
    </FooterContainer>
  );
};

CheckoutFooter.propTypes = {
  orderSummeryVariant: PropTypes.string,
};

export default CheckoutFooter;
